import { render, staticRenderFns } from "./siginIn.vue?vue&type=template&id=bdd601a8&scoped=true&"
import script from "./siginIn.vue?vue&type=script&lang=js&"
export * from "./siginIn.vue?vue&type=script&lang=js&"
import style0 from "./siginIn.vue?vue&type=style&index=0&id=bdd601a8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd601a8",
  null
  
)

export default component.exports